export const automatedSurveyQueueRoutes = {
  list: "",
  queueDetails: "queue/:id",
} as const;
